import { PaymentMethod } from '@shipstation/financial-services-ui-components';
import { Modal as ModalModule, Utils } from 'common';
import React, { useRef, useState } from 'react';
import { ActionType } from './ActionType.enum';
import AddPaymentMethod from './fsui/AddPaymentMethod.component';
import ManagePayment from './ManagePayment.component';

const { Modal, ModalButtonActionType } = ModalModule;
const { withLayoutAndModalContexts } = Utils;

const ManagePaymentModal = props => {
	const {
		modalId,
		data,
		modalContext: { closeModal },
	} = props;

	const addPaymentMethodRef = useRef();
	const title =
		data.action === ActionType.CREATE
			? 'Add Payment Method'
			: 'Edit Payment Method';
	const [btnText, setBtnText] = useState(null);
	const showAuctanePay = data.showAuctanePay;

	const apCallback = result => {
		data.callback(result);
		if (result.status === 'success') {
			closeModal(modalId);
		} else {
			// TODO: Error handling
		}
	};

	const handlePrimaryButtonClick = () => {
		if (
			addPaymentMethodRef.current &&
			addPaymentMethodRef.current.handleSubmit
		) {
			addPaymentMethodRef.current.handleSubmit();
		}
	};

	const handlePaymentTypeChange = paymentType => {
		if (paymentType === PaymentMethod.CreditCard) {
			setBtnText('Add Payment Method');
		} else if (paymentType === PaymentMethod.PayByBankUS) {
			setBtnText('Connect Bank');
		}
	};

	return showAuctanePay ? (
		<Modal
			className="ap-fsui-payment"
			modalId={modalId}
			header={title}
			primaryButton={{
				type: ModalButtonActionType.Ok,
				text: btnText,
				onClick: handlePrimaryButtonClick,
			}}
		>
			<AddPaymentMethod
				ref={addPaymentMethodRef}
				modalId={modalId}
				data={data}
				callback={apCallback}
				onPaymentTypeChange={handlePaymentTypeChange}
				isForCorpAccount={data.isCorpAccount}
			/>
		</Modal>
	) : (
		<Modal modalId={modalId} header={title} hideFooter>
			<ManagePayment modalId={modalId} data={data} />
		</Modal>
	);
};

export default withLayoutAndModalContexts(ManagePaymentModal);
